import logo from './logo.svg';
import './App.css';
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/HomePage";
import Profile from './pages/Profile';
import Connexion from "./pages/LoginForm";
import Inscription from "./pages/RegisterForm";
import PublicationForm from "./pages/PublicationForm";
import MyDocuments from './pages/MesDocuments';
import NewsForm from "./pages/NewsForm";
import ProgramForm from "./pages/ProgramForm";
import CandidaturesPage from './pages/Candidatures';
import {AuthProvider, useAuth } from "./contexts/AuthContext";

const App = () => {

  const PrivateRoute = ({ children }) => {
    const { user } = useAuth();
    return user ? children : <Connexion />;
  };

  return (
    <AuthProvider>
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/connexion" element={<Connexion />} />
        <Route path="/inscription" element={<Inscription />} />
        <Route path="/news" element={<NewsForm />} />
        <Route path="/publication" element={<PublicationForm />} />
        <Route path="/mes-documents/:studentId" element={<MyDocuments />} />
        <Route path="/candidatures/:studentId" element={<CandidaturesPage />} />
        <Route path="/program" element={<ProgramForm />} />
        <Route path="/profile/:universityId" element={<Profile />} />
      </Routes>
    </Router>
    </AuthProvider>
  );
};

export default App;